import { render, staticRenderFns } from "./ManageProductSpecCompanies.vue?vue&type=template&id=03250b48&scoped=true"
import script from "./ManageProductSpecCompanies.vue?vue&type=script&lang=js"
export * from "./ManageProductSpecCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03250b48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03250b48')) {
      api.createRecord('03250b48', component.options)
    } else {
      api.reload('03250b48', component.options)
    }
    module.hot.accept("./ManageProductSpecCompanies.vue?vue&type=template&id=03250b48&scoped=true", function () {
      api.rerender('03250b48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/productSpecs/ManageProductSpecCompanies.vue"
export default component.exports